import { acceptHMRUpdate, defineStore } from 'pinia';

import {
  BasicInformationPrimary,
  CandidateResumeOccupationsSecondary,
} from '@/types/pages/BasicInformation';
import { PrefectureFifth } from '@/types/models/prefecture';
import { PlatformType } from '@/types/models/PlatformType';

const initialState: BasicInformationPrimary = {
  is_mail_magazine_subscribed: true,
  email: '',
  auth0_user_id: '',
  first_name: undefined,
  last_name: undefined,
  first_name_kana: undefined,
  last_name_kana: undefined,
  gender: '3',
  birth_year: undefined,
  birth_month: undefined,
  birth_day: undefined,
  candidate_resume_desired_locations: [],
  profile_resume_desired_locations: [],
  profile_resume_occupations: [],
  prefecture_id: undefined,
  city_id: undefined,
  address: '',
  zip_code: undefined,
  platform: [],
  tel: '',
  experience: '',
};

export const useBaseInformationStore = defineStore('basicInformation.store', {
  state: (): BasicInformationPrimary => ({ ...initialState }),
  actions: {
    updateYearsOfExperience(occupationId: number, year: any) {
      const objectIndex = this.candidate_resume_occupations.findIndex(
        occupation => occupation.occupation_id == occupationId
      );
      this.candidate_resume_occupations[objectIndex].years_of_experience = year;
    },

    setResumeOccupations(occupations: CandidateResumeOccupationsSecondary[]) {
      this.profile_resume_occupations = occupations.map(occupation => ({
        id: occupation.id,
        occupation_id: occupation.occupation_id,
        years_of_experience: occupation.years_of_experience,
      }));
    },

    setResumeDesiredLocations(desiredLocations: PrefectureFifth[]) {
      this.profile_resume_desired_locations = desiredLocations.map(location => ({
        id: location.id,
        prefecture_id: location.prefecture_id,
        city_id: location.city_id,
      }));
    },

    setCandidatePlatform(platform: PlatformType) {
      if (platform === 'agent') {
        this.platform = [1];
      } else if (platform === 'direct') {
        this.platform = [7];
      } else if (platform === 'both') {
        this.platform = [1, 7];
      } else {
        this.platform = [];
      }
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBaseInformationStore, import.meta.hot));
}
